<script>
import elasticlunr from 'elasticlunr';

export default {
	name: 'faqs',

	props: {
    	faqs: Array
	},

	data() {
        let search_index = elasticlunr(function () {
            this.addField('question');
            this.addField('answer');
            this.setRef('id');
        });

        this.faqs.forEach((faq) => {
           search_index.addDoc(faq);
		});

		return {
            open_faqs: [
                this.faqs[0].id
			],
			cat: 0,
            search_term: '',
            search_index: search_index,
			search_results: this.faqs.map(faq => faq.id),
		};
	},


	methods: {
		selectCat(cat_id) {
			this.cat = cat_id;
		},

		toggleOpen(post_id) {
			let index = this.open_faqs.indexOf(post_id);
			if (index >= 0) {
				this.open_faqs.splice(index, 1);
			} else {
				this.open_faqs.push(post_id);
			}
		},

        isShown(post_id) {
            let _this = this;

            let results = _this.search_results;

            if (_this.cat) {
                results = results.filter((faq_id) => {
                    let faq = _this.faqs.find((f) => f.id === faq_id);
                    return faq.cat_ids.includes(this.cat);
                });
            }

            return results.includes(post_id);
        },
	},

	watch: {
        search_term(new_term, old_term) {
            if (new_term.trim() === '') {
                this.search_results = this.faqs.map(faq => faq.id);
			} else {
                this.search_results = this.search_index.search(new_term, {
                    expand: true
                }).map(result => parseInt(result.ref));
            }
		}
	}
};

</script>